
export default {
  filters: {
    reviewSignature (review) {
      const items = [review.name, review.role, review.location].filter(s => s)
      return items.join(', ')
    }
  },
  props: ['diagramId', 'reviews'],
  data: () => ({
    vmReviews: [],
    reviewsLimit: 3,
    vwReviewsToShow: [],
    totalReviews: null
  }),
  async fetch () {
    if (this.reviews) {
      this.vmReviews = this.reviews
    }
    if (this.vmReviews.length === 0) {
      this.vmReviews = await this.$backend.diagrams.retrieve(this.diagramId, 'reviews').then(d => d.results)
      if (this.vmReviews.length === 0) {
        this.vmReviews = await this.$backend.reviews.list()
      }
    }
    this.totalReviews = this.vmReviews.length
    this.vwReviewsToShow = this.vmReviews.splice(0, 3)
  },
  computed: {
    hasMoreReviews () {
      return this.vmReviews && this.totalReviews > this.reviewsLimit && (this.vwReviewsToShow.length === this.totalReviews)
    }
  },
  methods: {
    loadReviews () {
      this.vwReviewsToShow.push(...this.vmReviews.splice(0, 3))
    },
    hideMore () {
      this.vmReviews = this.vwReviewsToShow.splice(3)
    }
  },
  fetchOnServer: false
}
